<template>
  <div class="text-center">
    <v-bottom-sheet v-model="cookies" persistent hide-overlay inset>
      <v-sheet class="text-center cookiesFix"  data-testid="ServiceCookies-AcceptCookiesMessage">
        <h1 style="font-size: 16pt;">{{ instance.name}}</h1>
        <div class="pb-1 pt-0" data-testid="ServiceCookies-AcceptCookiesInformationText">
          {{ $t('service_policies.cookies_label_part1') }} {{ $t('service_policies.cookies_label_part2') }}
          <a @click="show_policies = !show_policies">{{$t('service_policies.cookies_label_part3')}}</a>
        </div>
        <p class="mb-6" v-if="instance.slug === 'rayados-mty'">
          <b>Pa’tu Butaca: </b>
          <br>
          <a target="_blank" href="https://cluvi-files.s3.us-east-2.amazonaws.com/6888821d-3ad1-490e-81fd-1c415c95555f/excel/c71d38eb-c6b6-4f09-ac43-7aeb7f0c5958.pdf">
            Términos y Condiciones de Uso del servicio de alimentos y bebidas a tu asiento en el estadio BBVA
          </a>
        </p>
        <v-btn color="error" @click="servicesCookies()" v-html="$t('common.accept_button_label')" data-testid="ServiceCookies-AcceptCookiesBtn"></v-btn>
      </v-sheet>
    </v-bottom-sheet>
    <v-dialog v-model="show_policies" persistent max-width="700px" height="700px" transition="dialog-transition">
      <v-card class="mx-auto">
        <v-toolbar dark dense class="toolbar-static">
          <v-toolbar-title v-html="$t('service_policies.polite_cookies')" />
          <v-spacer></v-spacer>
          <v-btn icon fab x-small @click="show_policies = false">
            <v-icon color="red">fa-light fa-xmark</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-html="policies"></v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { legal } from '@/services/api'
import { policie } from "@/services/domain";

export default {
  name: "ValidarCookies",
  data() {
    return {
      show_policies: false,
      cookies: true,
      array: [],
      alto: "127px",
      policies: ""
    };
  },
  created() {
    if (this.instance.slug === 'rayados-mty') this.alto = "247px";
    this.getDocumentCookies();
  },
  computed: {
    ...mapState('customer', ["instance"]),
    ...mapState('shared', ["legal"])
  },
  methods: {
    ...mapMutations('shared', ["setCookies"]),
    async servicesCookies () {
      this.setCookies(true);
      const response = await legal.servicesCookies({
        check: {
          check_cookies: this.legal.check_cookies
        }
      });
      if (response.data)  this.cookies = false;
    },
    getDocumentCookies () {
      if (this.html_content === null || !this.html_content) {
        policie.servicePolicies()
        .then(response => {
          this.policies = response.data;
        }).catch(error => {
          console.error(error);
        });
      };
    }
  }
};
</script>